<template>
<div class="contract-view">
    <div class="popup" :class="{ 'is-active': isFinalCompleteNewChildContract }">
      <div class="overlay"></div>
      <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
        <div class="card">
          <div class="card-body text-center">
            <div class="text-center p-2">
              <h3 class="font-weight-normal mb-2">ทำการปรับเปลี่ยนสัญญาเรียบร้อยแล้ว</h3>
              <p class="pr-4 pl-4">โปรดดูรายละเอียดสัญญาใหม่</p>
            </div>
            <a class="btn btn-primary btn-lg btn-block mt-5 mb-4" :href="$util.url('member/transaction-contract#/view/' + this.newChildContractId)">ไปที่สัญญาใหม่</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white pr-2 pl-2 pt-4 pb-4 text-center shadow-lg">
      <h5 class="font-weight-normal mb-1 text-danger">ผ่อนผันหรือเปลี่ยนแปลงสัญญา</h5>
      <p class="font-weight-normal m-0">#{{contract.contractNo}}</p>
    </div>
    <div class="container">

      <template v-if="this.contract.type === 'MORTGAGE'">

        <div class="row mt-4 mb-4">
          <div class="col">
              <h6 class="font-weight-normal text-secondary">ชื่อรายการบ้าน</h6>
              <input class="form-control" name="thingName" type="text" v-model="patch.thingPayload.thingName" />
              <h6 class="disputing-old-value">{{contract.info.thingPayload.thingName}}</h6>
          </div>
        </div>

        <div class="row mt-4 mb-4">
          <div class="col">
            <h6 class="font-weight-normal text-secondary">รูปถ่ายแนบสัญญา</h6>
            <ImageUploader v-model="patch.thingPayload.imageURLs" :api="$api.contract.request.thing.uploadPhoto"></ImageUploader>
          </div>
        </div>

        <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary" for="amount">จำนวนเงินที่ขอสินเชื่อ (จากสัญญาเดิม แก้ไขไม่ได้)</h6>
                <input class="form-control" name="amount" type="number" v-model.number="patch.moneyPayload.amount" :class="{'is-invalid': patch.moneyPayload.amount < 0}" :readonly="true">
                <h6 class="disputing-old-value">{{ contract.info.moneyPayload.amount | money }}</h6>
            </div>
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ดอกเบี้ย</h6>
                <input class="form-control" type="number" v-model="interestRaw" :class="{'is-invalid': (interestRaw < 0 || interestRaw > 100)}" />
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.interest * 100 }}%</h6>
            </div>
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ดอกเบี้ยผิดนัดชำระ</h6>
                <input class="form-control"  v-model="interestDisputeRaw" :class="{'is-invalid': (interestRaw < 0 || interestRaw > 100)}"/>
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.dispute_interest * 100 }}%</h6>
            </div>
        </div>

        <div class="row mt-4 mb-4">
          <div class="col">
              <h6 class="font-weight-normal text-secondary" for="duration">ระยะเวลาที่ขอกู้</h6>

              <div class="row">
                <div class="col-6">
                  <div class="form-group form-goobank">
                    <label for="duration">ระยะเวลาที่ขอกู้</label>
                    <select class="form-control is-default" name="durationYear" v-model="patch.moneyPayload.durationYear">
                        <template v-for="option in display.optionLists.durationYearMortgage">
                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                        </template>
                    </select>
                    <h6 class="disputing-old-value">{{contract.info.moneyPayload.durationYear}} ปี {{contract.info.moneyPayload.durationMonth}} เดือน</h6>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group form-goobank">
                    <label for="duration">&nbsp;</label>
                    <select class="form-control is-default" name="durationMonth" v-model="patch.moneyPayload.durationMonth">
                        <template v-for="option in display.optionLists.durationMonthMortgage">
                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                        </template>
                    </select>
                    <h6 class="disputing-old-value-2">&nbsp;</h6>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ชำระเงินทุกวันที่</h6>
                <select class="form-control is-default" name="paymentDay" :disabled="true" v-model="patch.moneyPayload.payOnEvery">
                  <template v-for="option in display.optionLists.payOnEvery">
                      <option :key="option.value" :value="option.value">วันที่ {{option.display}}</option>
                  </template>
                </select>
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.payOnEvery}}</h6>
            </div>
        </div>

      </template>

      <template v-if="this.contract.type === 'MONEY' || this.contract.type === 'THING'">

        <template v-if="contract.type === 'THING'">
          <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ชื่อรายการสินค้า</h6>
                <input class="form-control" name="thingName" type="text" v-model="patch.thingPayload.thingName" />
                <h6 class="disputing-old-value">{{contract.info.thingPayload.thingName}}</h6>
            </div>
          </div>

          <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary">เงินดาวน์ / เงินมัดจำ</h6>
                <input v-if="isDisputing" class="form-control" name="deposit" type="number" v-model.number="patch.thingPayload.downPaymentAmount" />
                <h6 :class="{'disputing-old-value': isDisputing}">{{contract.info.thingPayload.downPaymentAmount | money}}</h6>
            </div>
          </div>

          <div class="row mt-4 mb-4">
            <div class="col">
              <h6 class="font-weight-normal text-secondary">รูปถ่ายแนบสัญญา</h6>
              <ImageUploader v-model="patch.thingPayload.imageURLs" :api="$api.contract.request.thing.uploadPhoto"></ImageUploader>
            </div>
          </div>
        </template>

        <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary" for="amount">จำนวนเงินที่ขอกู้ (จากสัญญาเดิม แก้ไขไม่ได้)</h6>
                <input class="form-control" name="amount" type="number" v-model.number="patch.moneyPayload.amount" :class="{'is-invalid': patch.moneyPayload.amount < 0}" :readonly="true">
                <h6 class="disputing-old-value">{{ contract.info.moneyPayload.amount | money }}</h6>
            </div>
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ดอกเบี้ย</h6>
                <select class="form-control is-default" name="interest" v-model="patch.moneyPayload.interest">
                  <template v-for="option in display.optionLists.interest">
                      <option :key="option.value" :value="option.value">{{option.display}}</option>
                  </template>
                </select>
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.interest * 100 }}%</h6>
            </div>
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ดอกเบี้ยผิดนัดชำระ</h6>
                <select class="form-control is-default" name="dispute_interest" v-model="patch.moneyPayload.dispute_interest">
                  <template v-for="option in display.optionLists.interest">
                      <option :key="option.value" :value="option.value">{{option.display}}</option>
                  </template>
                </select>
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.dispute_interest * 100 }}%</h6>
            </div>
        </div>

        <div class="row mt-4 mb-4">
          <div class="col">

              <h6 class="font-weight-normal text-secondary" v-if="contract.type === 'MONEY'" for="duration">ระยะเวลาที่ขอกู้</h6>
              <h6 class="font-weight-normal text-secondary" v-else-if="contract.type === 'THING'" for="duration">ระยะเวลาการผ่อนสินค้า</h6>

              <div class="row">
                <div class="col-6">
                  <div class="form-group form-goobank">
                    <label v-if="contract.type === 'MONEY'" for="duration">ระยะเวลาที่ขอกู้</label>
                    <label v-if="contract.type === 'THING'" for="duration">ระยะเวลาการผ่อนสินค้า</label>
                    <select class="form-control is-default" name="duration" v-model="patch.moneyPayload.duration">
                        <template v-for="option in display.optionLists.duration">
                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                        </template>
                    </select>
                    <h6 class="disputing-old-value">{{contract.info.moneyPayload.duration}} เดือน</h6>
                  </div>
                </div>

              </div>
          </div>
        </div>
        <div class="row mt-4 mb-4">
            <div class="col">
                <h6 class="font-weight-normal text-secondary">ชำระเงินทุกวันที่</h6>
                <select class="form-control is-default" name="paymentDay" v-model="patch.moneyPayload.payOnEvery">
                  <template v-for="option in display.optionLists.payOnEvery">
                      <option :key="option.value" :value="option.value">วันที่ {{option.display}}</option>
                  </template>
                </select>
                <h6 class="disputing-old-value">{{contract.info.moneyPayload.payOnEvery}}</h6>
            </div>
        </div>

      </template>





      <div class="container">
        <div class="row bg-white pb-2 pl-2 pr-2">
          <template v-if="isCalculating()">
            <div class="col text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col text-center">
              <p class="m-2">จำนวนงวด</p>
              <p class="h5">{{patch.moneyPayload.duration}} งวด</p>
            </div>
          </template>
        </div>
        <div class="row bg-white mt-2 p-2">
          <div class="col text-center">
            <p class="m-0">ชำระเงินงวดละ</p>
            <template v-if="isCalculating()">
              <p>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
            <template v-else>
              <p class="h2 text-danger" v-if="patch.moneyPayload.amount > 0">{{display.disputing.payPerPeriod | money}}</p>
              <p class="h2 text-danger" v-else>?</p>
            </template>
          </div>
        </div>
      </div>

      <div class="row pt-4 pb-2">
          <button class="btn btn-primary btn-lg btn-block" style="margin-top:6px;margin-bottom:6px;" @click="submitPatch()">ทำการบันทึกการปรับเปลี่ยนใหม่</button>
          <button class="btn btn-light btn-lg btn-block" style="margin-top:6px;margin-bottom:6px;" @click="goBack">ย้อนกลับ</button>
      </div>
    </div>

    
</div>
</template>

<script>
import ImageViewer from '../../sub_components/ImageViewer'
import ImageUploader from '../../sub_components/ImageUploader'
import ContractFlowPairDisplay from '../../sub_components/ContractFlowPairDisplay'
import CreditBureauList from '../../sub_components/CreditBureauList'
import InvoiceList from '../../sub_components/InvoiceList'

export default {
  data: () => ({
    isFinalCompleteNewChildContract: false,
    newChildContractId: 0,

    interestRaw: 0,
    interestDisputeRaw: 0,

    display: {
      dueAmount: '?',
      paidAmount: '?',
      disputing: {
        payPerPeriod: '?',
        fee: '?',
        lender_fee: '?',
      },
      popup: {
        title: '',
        description: ''
      },
      optionLists: {
        interest: [
            { value: 0.00, display: '0 %' },
            { value: 0.01, display: '1 %' },
            { value: 0.02, display: '2 %' },
            { value: 0.03, display: '3 %' },
            { value: 0.04, display: '4 %' },
            { value: 0.05, display: '5 %' },
            { value: 0.06, display: '6 %' },
            { value: 0.07, display: '7 %' },
            { value: 0.08, display: '8 %' },
            { value: 0.09, display: '9 %' },
            { value: 0.10, display: '10 %' },
            { value: 0.11, display: '11 %' },
            { value: 0.12, display: '12 %' },
            { value: 0.13, display: '13 %' },
            { value: 0.14, display: '14 %' },
            { value: 0.15, display: '15 %' },
        ],
        duration: [
            { value: 1, display: '1 เดือน' },
            { value: 2, display: '2 เดือน' },
            { value: 3, display: '3 เดือน' },
            { value: 4, display: '4 เดือน' },
            { value: 5, display: '5 เดือน' },
            { value: 6, display: '6 เดือน' },
            { value: 7, display: '7 เดือน' },
            { value: 8, display: '8 เดือน' },
            { value: 9, display: '9 เดือน' },
            { value: 10, display: '10 เดือน' },
            { value: 11, display: '11 เดือน' },
            { value: 12, display: '1 ปี' },
            { value: 13, display: '1 ปี 1 เดือน' },
            { value: 14, display: '1 ปี 2 เดือน' },
            { value: 15, display: '1 ปี 3 เดือน' },
            { value: 16, display: '1 ปี 4 เดือน' },
            { value: 17, display: '1 ปี 5 เดือน' },
            { value: 18, display: '1 ปี 6 เดือน' },
            { value: 19, display: '1 ปี 7 เดือน' },
            { value: 20, display: '1 ปี 8 เดือน' },
            { value: 21, display: '1 ปี 9 เดือน' },
            { value: 22, display: '1 ปี 10 เดือน' },
            { value: 23, display: '1 ปี 11 เดือน' },
            { value: 24, display: '2 ปี' },
            { value: 25, display: '2 ปี 1 เดือน' },
            { value: 26, display: '2 ปี 2 เดือน' },
            { value: 27, display: '2 ปี 3 เดือน' },
            { value: 28, display: '2 ปี 4 เดือน' },
            { value: 29, display: '2 ปี 5 เดือน' },
            { value: 30, display: '2 ปี 6 เดือน' },
            { value: 31, display: '2 ปี 7 เดือน' },
            { value: 32, display: '2 ปี 8 เดือน' },
            { value: 33, display: '2 ปี 9 เดือน' },
            { value: 34, display: '2 ปี 10 เดือน' },
            { value: 35, display: '2 ปี 11 เดือน' },
            { value: 36, display: '3 ปี' },
            { value: 37, display: '3 ปี 1 เดือน' },
            { value: 38, display: '3 ปี 2 เดือน' },
            { value: 39, display: '3 ปี 3 เดือน' },
            { value: 40, display: '3 ปี 4 เดือน' },
            { value: 41, display: '3 ปี 5 เดือน' },
            { value: 42, display: '3 ปี 6 เดือน' },
            { value: 43, display: '3 ปี 7 เดือน' },
            { value: 44, display: '3 ปี 8 เดือน' },
            { value: 45, display: '3 ปี 9 เดือน' },
            { value: 46, display: '3 ปี 10 เดือน' },
            { value: 47, display: '3 ปี 11 เดือน' },
            { value: 48, display: '4 ปี' },
        ],
        durationYearMortgage: [
          // generate in populateDurationYearMortgage function
        ],
        durationMonthMortgage: [
          // generate in populateDurationMonthMortgage function
        ],
        payOnEvery: []
      },
    },
    patch: {
      moneyPayload: {
        haigoo: {
          id: -1,
          avatarPath: '',
          name: '',
          memberType: ''
        },
        korgoo: {
          id: -1,
          avatarPath: '',
          name: '',
          memberType: ''
        },
        amount: 0.00,
        interest: 0.00,
        dispute_interest: 0.00,
        duration: 1,
        payOnEvery: 1,
        fee: 0,
        perPeriod: 0
      },
      // have thingPayload if type = 'THING'
      thingPayload: {
        thingName: '',
        downPaymentAmount: 0.00,
        imageURLs: []
      }
    },
    contract: {
      id: -1,
      type: '', // 'MONEY' or 'THING'
      activeUserSide: '',
      status: '',
      datetime: 0,
      info: {
        moneyPayload: {
          haigoo: {
            id: -1,
            avatarPath: '',
            name: '',
            memberType: ''
          },
          korgoo: {
            id: -1,
            avatarPath: '',
            name: '',
            memberType: ''
          },
          amount: 0.00,
          interest: 0.00,
          duration: 1,
          durationYear: 1,
          durationMonth: 1,
          payOnEvery: 1,
          fee: 0,
          perPeriod: 0
        },
        // have thingPayload if type = 'THING'
        thingPayload: {
          thingName: '',
          downPaymentAmount: 0.00,
          imageURLs: []
        }
      }
    },
    calculateQueue: []
  }),
  async created () {
    this.populateOptions();

    const result = await this.$api.contract.list(this.$route.params.id);
    const data = result.data
    if (!data.success) {
      this.isCantReach = true
      this.errorData = data
      return
    }
    this.contract = data.contracts[0];

    this.patch = JSON.parse(JSON.stringify(this.contract.info))
    this.patch.moneyPayload.interest = parseFloat(this.patch.moneyPayload.interest)
    this.patch.moneyPayload.dispute_interest = parseFloat(this.patch.moneyPayload.dispute_interest)

    this.interestRaw = this.patch.moneyPayload.interest * 100
    this.interestDisputeRaw = this.patch.moneyPayload.dispute_interest * 100

    this.patch.moneyPayload.amount = this.patch.moneyPayload.remaining;
    this.contract.info.moneyPayload.amount = this.patch.moneyPayload.amount;

    this.patch.thingPayload.downPaymentAmount = parseFloat(this.patch.thingPayload.downPaymentAmount)
    delete(this.patch.moneyPayload.haigoo)
    delete(this.patch.moneyPayload.korgoo)
    delete(this.patch.moneyPayload.perPeriod)
    delete(this.patch.moneyPayload.fee)
    delete(this.patch.moneyPayload.lender_fee)
    this.populateOptions()
    this.populateDurationYearMortgage();
    this.populateDurationMonthMortgage();

    this.isPreProcessing = false
  },
  mounted () {

  },
  beforeDestroy () {

  },
  watch: {
    interestRaw: function (val) {
      this.patch.moneyPayload.interest = val / 100.00;
    },
    interestDisputeRaw: function (val) {
      this.patch.moneyPayload.interestDispute = val / 100.00;
    },
    patch: { // for disputing
      async handler () {
        await this.emitCalculate()
      },
      deep: true
    }
  },
  methods: { 
    populateOptions () {
        this.display.optionLists.payOnEvery = [];
        [10,15,20,25,28].forEach((elm) => {
            this.display.optionLists.payOnEvery.push({
                value: elm,
                display: elm
            })
        });
    },
    populateDurationYearMortgage () {
        this.display.optionLists.durationYearMortgage = [];
        let i = 3;
        for(i = 3; i<= 30; i++) {
            let year = i;
            let display = "";

            display = year + " ปี ";
            this.display.optionLists.durationYearMortgage.push({
                value: i,
                display: display
            });
        }
    },
    populateDurationMonthMortgage () {
        this.display.optionLists.durationMonthMortgage = [];
        let i = 0;
        for(i = 0; i<= 11; i++) {
            let month = i;
            let display = "";

            display = month + " เดือน ";
            this.display.optionLists.durationMonthMortgage.push({
                value: i,
                display: display
            });
        }
    },
    isCalculating () {
      if (this.calculateQueue.length > 0) return true
      return false
    },
    async emitCalculate () {
      this.isCantReach = false
      this.isNotEnoughMoney = false
      this.isCantReachWhenSubmit = false
      this.isPendingCalculateFee = true
      try {
        clearTimeout(this.calculateTimeout)
      } catch (e) { console.warn(e) }
      this.calculateTimeout = setTimeout(async () => {
        this.display.disputing.payPerPeriod = '?'
        this.display.disputing.fee = '?'
        this.display.disputing.lender_fee = '?'

        if(this.contract.type === 'MORTGAGE') {
          this.patch.moneyPayload.duration = this.patch.moneyPayload.durationYear * 12 + this.patch.moneyPayload.durationMonth;
          let dataTemp = await this.calculatePayPerPeriod();
          this.display.disputing.payPerPeriod = dataTemp.perPeriodRounded;
        } else {
          this.display.disputing.payPerPeriod = await this.calculatePayPerPeriod();
        }

        this.isPendingCalculateFee = false;
      }, 1500)
    },
    async calculatePayPerPeriod () {
        this.calculateQueue.push(1)
        let result;

        if (this.contract.type === 'MONEY') {
          result = await this.$api.contract.calculatePayPerPeriod(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration)
        } else if(this.contract.type === 'THING') {
          result = await this.$api.contract.calculatePayPerPeriod(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration, this.patch.thingPayload.downPaymentAmount)
        } else if(this.contract.type === 'MORTGAGE') {
          result = await this.$api.contract.calculatePMT(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration)
        }

        const data = result.data
        if (!data.success) {
          this.calculateQueue.pop()
          // this.isCantReach = true
          this.errorData = data
          return
        }
        this.calculateQueue.pop()

        if(this.contract.type === 'MORTGAGE') {
          return data;
        } else {
          return data.perPeriod;
        }
    },
    async submitPatch() {
      const result = await this.$api.contract.actions.haigoo.createChildContract.create(this.contract.id, this.patch);
      const data = result.data;
      this.newChildContractId = data.data.id;
      this.isFinalCompleteNewChildContract = true;
    },
    goBack () {
      this.$router.push({ name: 'transaction-contract-view', params: { id: this.$route.params.id } });
    },
  },
  components: {
    ImageViewer,
    ContractFlowPairDisplay,
    CreditBureauList,
    ImageUploader,
    InvoiceList
  },
  props: [] // isShowCredit passed by routes, isDisputing passed by routes
}
</script>

<style lang="scss">
.contract-view {
  .active-user-indicator {
      display: none;
    }
  .is-active-user {
    .active-user-indicator {
      display: inline-block;
    }
  }
  .disputing-old-value {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
    &::before {
      content: '(ค่าเดิม: '
    }
    &::after {
      content: ')'
    }
  }
  .disputing-old-value-2 {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
  }
}
</style>
